import React from 'react';
import CheckboxOrRadioGroupContext from './CheckboxOrRadioGroupContext.js';
import classes from './CheckboxOrRadioGroup.module.css.js';
import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';
import Text from '../../../Text/Text.js';

const CheckboxOrRadioGroupCaption = ({
  className,
  children,
  sx
}) => {
  const {
    captionId
  } = React.useContext(CheckboxOrRadioGroupContext);
  return /*#__PURE__*/jsx(Text, {
    className: clsx(className, classes.CheckboxOrRadioGroupCaption),
    id: captionId,
    sx: sx,
    children: children
  });
};
CheckboxOrRadioGroupCaption.displayName = "CheckboxOrRadioGroupCaption";

export { CheckboxOrRadioGroupCaption as default };
